//必配====================================
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import tool from '../../_lib/js/tool.js'
import '../../_lib/css/common.css'
import '../../_lib/css/animate.min.css'
import Api from './api/api.js'
import store from './store/store.js'
import { VueHammer } from 'vue2-hammer'
import page from './components/page.vue'
import pageS from '../../_components/page.vue'
import abpage from '../../_components/abpage.vue'
import load from './components/load.vue'
import rule from './components/rule.vue'
import p1 from './components/p1.vue'
import game from './components/game.vue'
import p2 from './components/p2.vue'
import p3 from './components/p3.vue'
import box from './components/box.vue'
import mine from './components/mine.vue'
import hb from './components/hb.vue'
// if(process.env.NODE_ENV==='development'){
// 	window.console.log(process.env.NODE_ENV)
// 	require('../../_mock/mock.js')
// }

Vue.config.ignoredElements = ['wx-open-launch-weapp']
import '@vant/touch-emulator';
import {
	Dialog,
	Toast,
} from 'vant'
Vue.config.productionTip = false
Vue.prototype.$tool = tool
Vue.prototype.$api = Api
Vue.prototype.$lg = function(param){
	window.console.log(param)
}
Vue.use(Vuex)
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(VueHammer)
Vue.component('pageS', pageS)
Vue.component('page', page)
Vue.component('abpage', abpage)
Vue.component('load', load)
Vue.component('p1', p1)
Vue.component('game', game)
Vue.component('rule', rule)
Vue.component('p2', p2)
Vue.component('p3', p3)
Vue.component('box', box)
Vue.component('mine', mine)
Vue.component('hb', hb)
//选配======================================
// import VConsole from 'vconsole';
// window.vConsole = new VConsole()

import {
	Picker
} from 'vant'
import 'vant/lib/index.css'
Vue.use(Picker)




window._hmt = window._hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?78a22a80a6ffadfb8bf91a2d3149cc6b";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();



window.requestAnimFrame = (function() {
	return window.requestAnimationFrame ||
		window.webkitRequestAnimationFrame ||
		window.mozRequestAnimationFrame ||
		window.oRequestAnimationFrame ||
		window.msRequestAnimationFrame ||
		function(callback) {
			window.setTimeout(callback, 1000 / 60);
		};
})();
new Vue({
	render: h => h(App),
	store: new Vuex.Store(store.store)
}).$mount('#app')
